<template>
	<div
		class="progress-input"
		:class="{ error: !isValid }"
		@click="$refs['textInput'].focus()"
	>
		<input ref="textInput" @input="handleInput" :value="value" />
		<span class="placeholder" :class="{ active: value }">{{
			placeholder
		}}</span>
		<span v-show="!isValid" class="noti">{{ validText }}</span>
	</div>
</template>

<script>
export default {
	name: 'ProgressInput',
	props: {
		value: {
			type: String,
			default: '',
		},
		placeholder: {
			type: String,
			default: '',
		},
		isValid: {
			type: Boolean,
			default: true,
		},
		validText: {
			type: String,
			default: '',
		},
	},
	mounted() {
		this.$refs['textInput'].focus()
	},
	watch: {
		placeholder() {
			this.$refs['textInput'].focus()
		},
	},
	data() {
		return {}
	},
	methods: {
		handleInput(e) {
			this.$emit('input', e.target.value)
		},
	},
}
</script>

<style lang="scss" scoped>
.progress-input {
	width: 100%;
	position: relative;
	&.error {
		input {
			border-color: #ff5746;
		}
	}
	input {
		width: 100%;
		height: 56px;
		border-radius: 8px;
		border: 1px solid #ddd;
		padding: 10px 14px 0 14px;
		font-size: 1rem;
	}
	input:focus {
		border-color: #000;
	}
	input:focus ~ .placeholder {
		font-size: 0.75rem;
		top: 5px;
	}
	.placeholder {
		position: absolute;
		font-size: 1rem;
		font-weight: 400;
		color: #999;
		display: block;
		top: 16px;
		left: 14px;
		transition: all 0.3s;
		background-color: unset !important;
		&.active {
			font-size: 0.75rem;
			top: 5px;
		}
	}
	.noti {
		font-size: 0.75rem;
		color: #ff5746;
		font-weight: 400;
		display: block;
		padding-left: 16px;
		background-image: url(~@/assets/svg/icon-error_r.svg);
		background-repeat: no-repeat;
		background-position: center left 0;
		margin-top: 4px;
	}
}
</style>
